import React, { Fragment, useContext } from "react";
import AppContext from "./AppContext";
import { OffersText } from "./Texts.js";

export const Offers = () => {
	const context = useContext(AppContext);
	const isDE = context.lang.get === "en";

	return (
		<Fragment>
			<section className="page-section portfolio" id="offer">
				<div className="container">
					<div className="text-center">
						<h2 className="page-section-heading text-secondary mb-0 d-inline-block">
							{isDE ? "ANGEBOT" : "OFFERS"}
						</h2>
					</div>

					<div className="divider-custom">
						<div className="divider-custom-line"></div>
						<div className="divider-custom-icon">
							<i className="fas fa-star"></i>
						</div>
						<div className="divider-custom-line"></div>
					</div>

					<div className="row row-cols-2 row-cols-md-4 g-4 text-center">
						{OffersText.map((item, i) => (
							<div className="col" key={i}>
								<div className="offer-icon mb-3">
									<i className={item.icon}></i>
								</div>
								<h6 className="fw-bold text-secondary mb-2">
									{isDE ? item.title_DE : item.title_ENG}
								</h6>
								<p className="text-muted small mb-0">
									{isDE ? item.text_DE : item.text_ENG}
								</p>
							</div>
						))}
					</div>
				</div>
			</section>
		</Fragment>
	);
};

export default Offers;
